import { useState } from "react"
import { FaSearch } from "react-icons/fa"

// Searchbar component for table pages

interface SearchbarProps {
  onSearch: (query: string) => void
  placeholder?: string
}

export default function Searchbar({ onSearch, placeholder = "Search..." }: SearchbarProps) {
  const [searchTerm, setSearchTerm] = useState("")

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchTerm(value)
    onSearch(value)
  }

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <FaSearch className="w-5 h-5 text-gray-500" />
      </div>
      <input
        type="text"
        className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleSearch}
      />
    </div>
  )
}
